export const environment = {
  // production: "false",
  // basePath: "https://bmstest.azurewebsites.net",
  // apiUrl: "https://bmstest.azurewebsites.net/api",

  // NSC Dev
  // production: true,
  // basePath: 'https://nscbudgets-dev.shipperscouncil.gov.ng',
  // apiUrl: 'https://nscbudgets-dev.shipperscouncil.gov.ng/api',

  // NSC Live
  production: "true",
  basePath: "https://nscbudgets-api-fd-ewbrb5drfwa4hte0.z02.azurefd.net",
  apiUrl: "https://nscbudgets-api-fd-ewbrb5drfwa4hte0.z02.azurefd.net/api",
};


//https://dev.azure.com/nscapp/nscBudgets/_git/FrontEnd

//https://TargetAfri@dev.azure.com/TargetAfri/BMS/_git/FrontEnd